<template>
  <section class="project-detail">
    <div class="container">
      <!-- Lower Content -->
      <div class="lower-content">
        <div class="row">
          <!-- Left Column -->
          <div class="text-column col-lg-8 col-md-12 col-sm-12 text-left">
            <!-- Course Image -->
            <div class="upper-box">
              <div class="single-item-carousel owl-carousel owl-theme">
                <figure class="image">
                  <img :src="course.image" alt="Course Image" />
                </figure>
              </div>
            </div>
            <!-- Instructor & Pricing Section -->
            <div class="course-meta2 review style2 clearfix mb-30">
              <ul class="left">
                <li>
                  <div class="author">
                    <div class="thumb">
                      <div
                        :style="{
                          backgroundImage: course.facilitators[0]?.image ? `url(${course.facilitators[0].image})` : '',
                          backgroundSize: 'cover',
                          backgroundPosition: 'center',
                          backgroundRepeat: 'no-repeat',
                          height: '50px',
                          width: '50px',
                          borderRadius: '50%',
                        }"
                      ></div>
                    </div>

                    <div class="text text-left">
                      <a>{{ course.instructor }}</a>
                      <p>Coach</p>
                    </div>
                  </div>
                </li>
                <li class="categories text-left">
                  <div class="author">
                    <div class="text">
                      <a href="#" class="course-name">{{ course.category }}</a>
                      <p>Category</p>
                    </div>
                  </div>
                </li>
              </ul>
              <ul class="right">
                <li class="price">{{ course.price }}</li>
              </ul>
            </div>

            <!-- Horizontal Divider -->
            <div class="divider"></div>

            <!-- Course Overview -->
            <div class="inner-column">
              <h3>{{ course.title }}</h3>
              <!-- <p>{{ course.description }}</p> -->
              <div class="dynamic-description" v-html="course.description"></div>

              <h3 style="text-align: left; margin-top: 2rem">Meet your facilitators</h3>

              <div class="row course-details-teachers-main">
                <div v-for="fac in course.facilitators" :key="fac.name" class="col-lg-6 col-md-6 col-sm-12">
                  <div class="class-item mb-30">
                    <!-- class-img -->
                    <div class="class-img">
                      <div class="class-img-outer">
                        <a>
                          <img :src="fac.image" alt="Facilitator" />
                        </a>
                      </div>
                    </div>
                    <!-- class-img -->
                    <!-- schedule -->

                    <!-- schedule-end -->
                    <!-- class-content -->
                    <div class="class-content" style="text-align: left">
                      <h4 class="title mb-0">
                        <a>{{ fac.name }}</a>
                      </h4>
                      <small class="mb-100">{{ fac.title }}</small
                      ><br /><br />
                      <p>
                        {{ fac.bio }}
                      </p>
                    </div>
                    <!-- class-content-end -->
                  </div>
                </div>
              </div>

              <!-- Course Content Accordion -->
              <h3 style="text-align: left; margin-top: 2rem">Course Content</h3>
              <p style="text-align: left">{{ course.syllabus.length }} lectures.</p>
              <div class="faq-wrap faq-wrap2 pt-30 wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s">
                <div id="accordionExample" class="accordion">
                  <div class="card">
                    <div id="headingThree" class="card-header">
                      <h2 class="mb-0">
                        <button class="faq-btn" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree">
                          Topics we will cover
                          <span>{{ course.syllabus.length }} lectures.</span>
                        </button>
                      </h2>
                    </div>
                    <div id="collapseThree" class="collapse show" data-bs-parent="#accordionExample">
                      <div class="card-body">
                        <div class="leactures" style="text-align: left">
                          <ul>
                            <li v-for="(item, index) in course.syllabus" :key="index">
                              <a href="#">
                                <div class="text"><i class="fal fa-edit"></i> {{ item.title }}</div>
                                <div class="time">
                                  <i class="fal fa-clock"></i> Duration:
                                  {{ item.duration }}
                                </div>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Right Column (Sidebar) -->
          <div class="col-lg-4 desktop-only">
            <aside class="sidebar-widget info-column">
              <div class="inner-column3">
                <h3>Course Details</h3>
                <ul class="project-info clearfix">
                  <li>
                    <div class="priceing">
                      <strong>Call for pricing</strong>
                    </div>
                  </li>
                  <li>
                    <strong>Instructor:</strong>
                    <span>{{ course.instructor }}</span>
                  </li>
                  <li>
                    <strong>Lectures:</strong>
                    <span>{{ course.syllabus.length }}</span>
                  </li>
                  <li>
                    <strong>Duration:</strong>
                    <span>{{ course.duration }}</span>
                  </li>
                  <li>
                    <strong>Capacity:</strong>
                    <span>{{ course.capacity }} students</span>
                  </li>
                  <li>
                    <strong>Language:</strong>
                    <span>{{ course.language }}</span>
                  </li>
                  <li>
                    <strong>Financing:</strong>
                    <span>{{ course.financing }}</span>
                  </li>
                  <li>
                    <div class="slider-btn">
                      <button
                        class="btn ss-btn"
                        style="height: 50px; font-weight: 700"
                        :disabled="isEnrolled"
                        @click="handleEnroll"
                      >
                        {{ isEnrolled ? 'Already Enrolled' : 'Enroll Now' }}
                      </button>
                      <small>{{ isEnrolled ? 'Please visit dashboard' : '' }}</small>
                    </div>
                  </li>
                </ul>
              </div>
            </aside>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div v-if="showLoginModal" class="modal-overlay">
    <div class="modal">
      <h3>Login Required</h3>
      <p>You need to log in to enroll in this course.</p>
      <div class="modal-buttons">
        <button class="btn ss-btn" @click="redirectToLogin">Go to Login</button>
        <button class="btn cancel-btn" @click="showLoginModal = false">Close</button>
      </div>
    </div>
  </div>
  <!-- Registration Confirmation Modal -->
  <div v-if="showRegistrationModal" class="modal-overlay course-registration-modal">
    <div class="modal fade show d-block" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg" role="document" style="margin: 0">
        <div class="modal-content p-4">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">Confirm Your Details</h4>
            <!-- <button
              type="button"
              class="close-btn"
              @click="showRegistrationModal = false"
            >
              <span><i class="fa fa-xmark"></i></span>
            </button> -->
          </div>

          <!-- Modal Body -->
          <div class="modal-body">
            <p class="text-muted">Please confirm your details before enrolling in this course.</p>

            <form @submit.prevent="submitEnrollment">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="firstName">First Name</label>
                    <input
                      id="firstName"
                      v-model="registrationData.firstName"
                      type="text"
                      class="form-control"
                      required
                    />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="lastName">Last Name</label>
                    <input
                      id="lastName"
                      v-model="registrationData.lastName"
                      type="text"
                      class="form-control"
                      required
                    />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="email">Email</label>
                    <input id="email" v-model="registrationData.email" type="email" class="form-control" disabled />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="phone">Phone Number</label>
                    <input id="phone" v-model="registrationData.phone" type="tel" class="form-control" required />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="city">City</label>
                    <input id="city" v-model="registrationData.city" type="text" class="form-control" required />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="province">Province</label>
                    <select id="province" v-model="registrationData.province" class="form-control" required>
                      <option value="AB">Alberta</option>
                      <option value="BC">British Columbia</option>
                      <option value="MB">Manitoba</option>
                      <option value="NB">New Brunswick</option>
                      <option value="NL">Newfoundland and Labrador</option>
                      <option value="NS">Nova Scotia</option>
                      <option value="ON">Ontario</option>
                      <option value="PE">Prince Edward Island</option>
                      <option value="QC">Quebec</option>
                      <option value="SK">Saskatchewan</option>
                      <option value="NT">Northwest Territories</option>
                      <option value="NU">Nunavut</option>
                      <option value="YT">Yukon</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="form-group">
                    <label for="language">Languages Spoken</label>
                    <select id="language" v-model="registrationData.language" class="form-control" required>
                      <option value="English">English</option>
                      <option value="French">French</option>
                      <option value="Mandarin">Mandarin</option>
                      <option value="Cantonese">Cantonese</option>
                      <option value="Spanish">Spanish</option>
                      <option value="Punjabi">Punjabi</option>
                      <option value="Tagalog">Tagalog</option>
                      <option value="Arabic">Arabic</option>
                      <option value="Hindi">Hindi</option>
                      <option value="Urdu">Urdu</option>
                      <option value="Pashto">Pashto</option>
                      <option value="German">German</option>
                      <option value="Italian">Italian</option>
                      <option value="Portuguese">Portuguese</option>
                      <option value="Korean">Korean</option>
                      <option value="Russian">Russian</option>
                      <option value="Japanese">Japanese</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <!-- Modal Footer -->
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="showRegistrationModal = false">Cancel</button>
            <button type="submit" class="btn btn-primary" @click="submitEnrollment">Confirm Enrollment</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Confirmation Message After Enrollment -->
  <div v-if="showSuccessMessage" class="modal-overlay course-registration-success-modal">
    <div class="modal">
      <h3>Enrollment Request Sent</h3>
      <p>
        You have successfully applied for this course. Our support team will reach out to you within 48 hours to arrange
        payment. Once the payment is completed, your enrollment will be confirmed.
      </p>
      <div class="modal-buttons">
        <button class="btn ss-btn" @click="redirectToDashboard">Go to Dashboard</button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/services/api';
import courseService from '@/services/courseService';

export default {
  name: 'CourseDetails',
  data() {
    return {
      course: {
        title: '',
        description: '',
        price: '',
        duration: '',
        image: '',
        instructorImage: '', // New field for instructor image
        category: '',
        instructor: '',
        capacity: 0,
        language: '',
        financing: '',
        syllabus: [],
        facilitators: [],
      },
      isLoggedIn: false, // ✅ Check if user is logged in
      showLoginModal: false, // ✅ Controls login modal visibility
      redirectUrl: '',
      showRegistrationModal: false,
      showSuccessMessage: false,
      registrationData: {
        // ✅ Pre-filled user registration data
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        city: '',
        province: '',
        language: '',
      },
      isEnrolled: false,
    };
  },
  // async created() {
  //   const courseId = this.$route.params.id;
  //   const { data } = await courseService.getCourseById(courseId);
  //   this.course = data;
  // },
  async mounted() {
    const courseId = this.$route.params.id;
    const { data } = await courseService.getCourseById(courseId);
    this.course = data;
    this.checkLoginStatus();
    this.loadCourse();

    if (this.isLoggedIn) {
      await this.fetchUserProfile(); // ✅ Fetch user profile if logged in
      await this.checkEnrollmentStatus(); // ✅ Check if user is enrolled
    }
  },
  methods: {
    async fetchUserProfile() {
      try {
        const token = localStorage.getItem('userToken');
        if (!token) return;

        const response = await api.get('/auth/profile', {
          headers: { Authorization: `Bearer ${token}` },
        });

        const user = response.data;

        this.registrationData = {
          // ✅ Pre-fill registration form
          firstName: user.firstName,
          lastName: user.lastName,
          email: user.email,
          phone: user.phone,
          city: user.city,
          province: user.province,
          language: user.language,
        };
      } catch (error) {
        console.error('Error fetching profile:', error.response?.data?.message || error.message);
      }
    },
    checkLoginStatus() {
      this.isLoggedIn = !!localStorage.getItem('userToken'); // ✅ Check if user is logged in
    },
    async loadCourse() {
      const courseId = this.$route.params.id;
      const { data } = await courseService.getCourseById(courseId);
      this.course = data;
    },
    handleEnroll() {
      if (!this.isLoggedIn) {
        this.showLoginModal = true; // ✅ Show modal if not logged in
        this.redirectUrl = this.$route.fullPath; // ✅ Save current course URL
      } else {
        this.showRegistrationModal = true;
      }
    },
    redirectToLogin() {
      localStorage.setItem('redirectAfterLogin', this.redirectUrl); // ✅ Store redirect URL
      this.$router.push('/login'); // ✅ Redirect to login page
    },
    async submitEnrollment() {
      try {
        const token = localStorage.getItem('userToken');
        const response = await api.post(
          '/enrollments',
          {
            courseId: this.$route.params.id,
            ...this.registrationData, // ✅ Send user data
          },
          { headers: { Authorization: `Bearer ${token}` } },
        );

        if (response.status === 201) {
          this.showRegistrationModal = false; // ✅ Close modal
          // this.$router.push("/dashboard/mycourses"); // ✅ Redirect to dashboard
          this.showSuccessMessage = true;
        }
      } catch (error) {
        console.error('Enrollment failed:', error.response?.data?.message || error.message);
        alert('Error enrolling in the course. Please contact support.');
      }
    },
    async checkEnrollmentStatus() {
      try {
        const token = localStorage.getItem('userToken');
        if (!token) return;

        const response = await api.get('/enrollments/my-enrollments', {
          headers: { Authorization: `Bearer ${token}` },
        });

        const userEnrollments = response.data;

        // ✅ Check if the user is enrolled in this course
        this.isEnrolled = userEnrollments.some((enrollment) => enrollment.courseId._id === this.course._id);
      } catch (error) {
        console.error('Error checking enrollment status:', error);
      }
    },
    redirectToDashboard() {
      this.$router.push('/dashboard/mycourses'); // ✅ Redirect user to dashboard
    },
  },
};
</script>

<style scoped>
.instructor-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
}
.instructor-info {
  display: flex;
  align-items: center;
}
.instructor-img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 10px;
}
.instructor-details,
.category-details {
  margin-right: 20px;
}
.instructor-name,
.category-name {
  font-weight: bold;
}
.price-section {
  text-align: right;
}
.price {
  font-size: 24px;
  color: #1d3557;
  font-weight: bold;
}
.divider {
  border-top: 2px solid #27ae60;
  margin: 20px 0;
}
.syllabus-list {
  list-style: none;
  padding: 0;
}
.syllabus-item {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  border-bottom: 1px solid #ddd;
}
.syllabus-item .text {
  display: flex;
  align-items: center;
  color: #333;
}
.syllabus-item .text i {
  margin-right: 10px;
  color: #f7941e;
}
.syllabus-item .time {
  color: #606060;
}
.faq-btn {
  background-color: #f0f0f0;
  border: none;
  padding: 10px 15px;
  text-align: left;
  width: 100%;
  color: #333;
}
.faq-btn:hover {
  background-color: #e0e0e0;
}
.card-body {
  background-color: #f9f9f9;
}
.course-details {
  max-width: 800px;
  margin: auto;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);
}

button {
  background-color: #42b983;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

button:hover {
  background-color: #36976f;
}

.course-details-teachers-main .class-img {
  display: flex;
  justify-content: center;
  align-items: normal;
  overflow: hidden;
  width: 100%;
  height: 350px; /* Adjust height as needed */
}

.course-details-teachers-main .class-img img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* Ensures images fill the container without stretching */
  border-radius: 10px; /* Optional: adds rounded corners */
}
.class-img-outer {
  width: 100%;
}

/* this is custom CSS */

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.modal:not(.course-registration-modal .modal, .course-registration-success-modal .modal) {
  background: white;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  width: 350px;
  display: block;
  height: 200px;
  left: auto;
  top: auto;
}

.course-registration-modal .modal {
  background: white;
  border-radius: 10px;
  text-align: center;
  width: 600px;
  display: block;
  height: auto;
  left: auto;
  top: auto;
  text-align: left;
}

.course-registration-success-modal .modal {
  background: white;
  border-radius: 10px;
  text-align: center;
  width: 600px;
  display: block;
  height: auto;
  left: auto;
  top: auto;
  text-align: left;
  padding: 2rem;
}

.modal-buttons {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  gap: 10px;
}

.btn {
  padding: 10px 15px;
  border: none;
  cursor: pointer;
  font-size: 14px;
}

.ss-btn {
  background: #27ae60;
  color: white;
}

.cancel-btn {
  background: #ccc;
}
.modal-footer {
  border: none;
}
.btn-secondary {
  color: #fff !important;
  background-color: #6c757d !important;
  border-color: #6c757d !important;
}
.close-btn {
  background-color: red;
}
</style>
